import useBusinessNavigate from '../lib/useBusinessNavigate.js';
import Loading from '../components/Loading';
import { useEffect, useState } from 'react';
import * as Toast from '../lib/Toast.js';
import { get, post } from '../lib/Api';
import { Link, useNavigate, useParams } from 'react-router-dom';
import RequiresAuth from '../components/RequiresAuth.jsx';
import usePostApi from '~/lib/usePostApi.js';

const DoClone = ({ businessId, token }) => {
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URL(document.location).searchParams;
        const source = params.get('ref');

        post(`/api/clone/${businessId}/${token}`, {
            source: source,
        })
            .then(result => {
                Toast.success(`Successfully copied ${result.name}`);
                navigate(`/business/${result.id}`);
            })
            .catch(err => {
                console.log(err);
                setError(
                    'Sharing link was invalid. Please ask the business for a new link',
                );
            });
    }, []);

    return (
        <div className="min-h-screen w-full flex items-center justify-center">
            {!error && <Loading />}
            {!!error && <div className="p-6 panel text-red-500">{error}</div>}
        </div>
    );
};

const JoinPage = ({}) => {
    const navigate = useNavigate();
    const { id, token } = useParams();

    return (
        <RequiresAuth>
            <DoClone businessId={id} token={token} />
        </RequiresAuth>
    );
};

export default JoinPage;
